import React, { FC, useCallback, useEffect } from 'react';
import { Trans } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { UiButton } from 'src/components/UI/Button';
import { UiInnerNotSPALink } from 'src/components/UI/InnerNotSPALink';
import { UiLoader } from 'src/components/UI/loaders';
import { commonCurrentPartnerSelector } from 'src/store/commonPart/selector';
import { commonSlice } from 'src/store/commonPart/slice';
import { addDOMClass } from 'src/utils/DOM';
import { hardRedirect } from 'src/utils/hardRedirect';
import { isStringHtml } from 'src/utils/http';
import { useTHelper } from 'src/utils/i18n';

type Props = {
  message?: string; // string | html
};

export const ErrorPage: FC<Props> = ({ message }) => {
  const dispatch = useDispatch();

  const tHelper = useTHelper('errorPage');

  /** let the application know this page is active */
  useEffect(() => {
    dispatch(commonSlice.actions.toggleErrorPageShown(true));
  }, [dispatch]);

  const { response } = useSelector(commonCurrentPartnerSelector);

  const goBack = useCallback(() => {
    hardRedirect(document.referrer || '/');
  }, []);

  useEffect(() => {
    addDOMClass('nav.r-h-navbar', 'd-none');
  }, []);

  return response ? (
    <div id="site-error" className="text-center">
      <div className="error_group_icon animated bounce" style={{ animationDuration: '2.5s !important' }} />

      <p className="error-title HeaderTextColor">{tHelper('title')}</p>

      {message && (
        <>
          {isStringHtml(message) ? (
            // eslint-disable-next-line react/no-danger
            <div className="error-message" dangerouslySetInnerHTML={{ __html: message }} />
          ) : (
            <p className="error-message">{message}</p>
          )}
        </>
      )}

      <UiButton primary effects className="btn-back PrimaryButtonColor PrimaryButtonTextColor" onClick={goBack}>
        {tHelper('backButton')}
      </UiButton>

      {!!response.PartnerID && (
        <p className="contact-us">
          <Trans i18nKey="errorPage.contactUs" values={{ contactEmail: response.ContactEmail }}>
            <UiInnerNotSPALink className="contact-email LinkTextColor" href={`mailto:${response.ContactEmail}`}>
              1
            </UiInnerNotSPALink>
          </Trans>
        </p>
      )}
    </div>
  ) : (
    <UiLoader fullScreenCentered />
  );
};
